import React, { useMemo } from "react";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useExpanded,
  useGroupBy,
  useSortBy,
  usePagination,
  useColumnOrder,
  useBlockLayout,
  useResizeColumns,
} from "react-table";
import MOCK_DATA from "./MOCK_DATA.json";
import {
  COLUMNS,
  GROUPED_COLUMNS,
  //tblColumns,
  PortfolioColumns,
} from "./columns";
import "./table.css";
import { GlobalFilter } from "./GlobalFilter";
import { ColumnFilter } from "./ColumnFilter";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import AlignHorizontalLeftIcon from "@mui/icons-material/AlignHorizontalLeft";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import { Checkbox } from "./Checkbox";

import styled from "styled-components";
//import { useSelector } from "react-redux";

const Styles = styled.div`
  table {
    display: inline-block;
    border-spacing: 0;

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0;

      ${
        "" /* In this example we use an absolutely position resizer,
       so this is required. */
      }
      position: relative;

      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        background: #a4a4a4;
        ${"" /* darkgreen */}
        width: 3px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;
        ${"" /* prevents from scrolling while dragging on touch devices */}
        touch-action:none;

        &.isResizing {
          background: orange;
        }
      }
    }
  }
`;

export const MostAdvancedTable = ({ propData, tblColumns }) => {
  //export const MostAdvancedTable = () => {
  //  const propData = useSelector((state) => state.portfolio.rData);

  //console.log("MAT =", propData);

  //const columns = useMemo(() => COLUMNS, []);
  //const columns = useMemo(() => GROUPED_COLUMNS, []);
  //const data = useMemo(() => MOCK_DATA, []);
  const columns = useMemo(() => tblColumns, []);
  //const columns = useMemo(() => PortfolioColumns(propData), []); //tblColumns, []);
  const data = useMemo(() => propData, [propData]);
  //console.log("Data =", data);

  //console.log(columns, propData, data)

  //add 'Filter: ColumnFilter' to all columns
  const defaultColumn = useMemo(() => {
    return { Filter: ColumnFilter, minWidth: 30 }; //, width: 200, maxWidth: 400
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //rows,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
    resetResizing,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: { pageSize: 50 }, //initialState: {pageIndex:2} //== start from Page 3
    },
    useFilters,
    useGlobalFilter,
    useColumnOrder,
    useGroupBy,
    useSortBy,
    useExpanded,
    usePagination,
    useBlockLayout,
    useResizeColumns
  );

  // const { globalFilter } = state;
  // const {pageIndex} = state
  const { globalFilter, pageIndex, pageSize } = state;

  const changeOrder = () => {
    setColumnOrder([
      "id",
      "first_name",
      "last_name",
      "phone",
      "country",
      "date_of_birth",
    ]);
  };

  const makeBcg = (type, value) => {
    const style = {};
    if (type == "Balance" || type == "Rewards") {
      const max = type == "Balance" ? 500 : 2.5;
      const min = type == "Balance" ? 150 : 0;
      const trim = type == "Balance" ? 92 : 0.35;

      const colors = [
        "#ff5722",
        "#ff9800",
        "#ffc107",
        "#ffeb3b",
        "#cddc39",
        "#8bc34a",
        "#4caf50",
      ];
      let p = Math.round((value + min) / trim) - 1;
      style.background = colors[p < 0 ? 0 : p];
    }
    return style;
  };

  return (
    <>
      <div className="topContainer">
        <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
        <div>
          {/*<button onClick={changeOrder}>Change column order</button>*/}
          {allColumns.map((column) => (
            <span key={column.id} className="spanCheckbox">
              <label>
                <input type="checkbox" {...column.getToggleHiddenProps()} />
                {column.Header}
              </label>
            </span>
          ))}
          <span className="spanCheckbox">
            <Checkbox {...getToggleHideAllColumnsProps()} /> Toggle All
          </span>
        </div>
      </div>
      <Styles>
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th key={column.id}>
                    <div
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <span className="sortSpan">
                        {column.canGroupBy ? (
                          <span {...column.getGroupByToggleProps()}>
                            {" "}
                            {
                              column.isGrouped ? (
                                <FormatAlignLeftIcon
                                  style={{
                                    fontSize: "medium",
                                    marginRight: "5px",
                                    color: "#006400",
                                  }}
                                /> /*"🛑 "*/
                              ) : (
                                <AlignHorizontalLeftIcon
                                  style={{
                                    fontSize: "medium",
                                    marginRight: "5px",
                                    color: "#646464",
                                  }}
                                />
                              ) /*"👊 "*/
                            }
                          </span>
                        ) : null}
                        {column.render("Header")}
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <ArrowDownward className="sortIcon" />
                          ) : (
                            <ArrowUpward className="sortIcon" />
                          )
                        ) : (
                          <ArrowUpward className="sortIconHover" />
                        )}
                      </span>
                    </div>
                    <div className="thFilter">
                      {column.canFilter ? column.render("Filter") : null}
                    </div>
                    <div
                      {...column.getResizerProps()}
                      className={`resizer ${
                        column.isResizing ? "isResizing" : ""
                      }`}
                    />
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              // console.log(row.getRowProps()); //including key like row_4
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    // console.log(cell.getCellProps()); //including key like cell_7_Reward
                    return (
                      <td {...cell.getCellProps()}>
                        {/*cell.render("Cell")*/}
                        <div style={makeBcg(cell.column.Header, cell.value)}>
                          {cell.isGrouped ? (
                            <>
                              <span {...row.getToggleRowExpandedProps()}>
                                {row.isExpanded ? "👇 " : "👉 "}
                              </span>{" "}
                              {cell.render("Cell")} ({row.subRows.length})
                            </>
                          ) : cell.isAggregated ? (
                            cell.render("Aggregated")
                          ) : cell.isPlaceholder ? null : (
                            cell.render("Cell")
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Styles>
      <div>
        <span>
          Page <strong>{pageIndex + 1}</strong> of {pageOptions.length}{" "}
        </span>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </button>
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          Previous
        </button>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          Next
        </button>
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>
        <span className="btnGotoPage">
          Go to page:{" "}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const pageNumber = e.target.value
                ? Number(e.target.value) - 1
                : 0;
              gotoPage(pageNumber);
            }}
            style={{ width: "50px" }}
          />
        </span>
        <span className="btnPageSize">
          Show:{" "}
          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {/* <label>Show</label> */}
                {pageSize}
              </option>
            ))}
          </select>
          rows
        </span>
        <button onClick={resetResizing} className="btnResetResize">
          Reset Resizing
        </button>
      </div>
    </>
  );
};
